module.exports = __webpack_public_path__ + "img/chart1.bd357fee.png";